export { default } from "bullitttime-embermodelsgochips/adapters/translation";
